import React, {Suspense} from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import {setupStore} from "./store/store";
import {Provider} from "react-redux";
import {HelmetProvider} from "react-helmet-async";
import {readLanguageFromPath} from './config/languages';
import './18n';

import './App.css';
import './common/css/btnMain.css';
import './common/css/ContainerMain.css';
import './common/css/ChatMain.css';
import './common/css/ChatRoomItemMain.css';
import './common/css/TooltipMain.css';
import './common/css/chatRoomViewMain.css';
import './common/css/MenuHeaderMain.css';
import './common/css/HeaderMain.css';
import './common/css/ProfileMain.css';
import './common/css/SpecialistProfileMain.css';
import './common/css/TestPageMain.css';
import './common/css/Main.css';
import './common/css/ModalMain.css';
import './common/css/SchedulerMain.css';
import {Loader} from "./components/loader/Loader";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const store = setupStore()

// Cloudflare redirects the slashless form in production; this covers the dev server and any origin
// without that rule, so the router always sees the one URL shape every link is built in.
const {pathname, search, hash} = window.location
if (!pathname.endsWith('/')) {
    window.history.replaceState(window.history.state, '', `${pathname}/${search}${hash}`)
}

// The prefix is handed to react-router as a basename, so every RoutePath, navigate()
// and <NavLink> keeps its prefix-free form and gains the prefix automatically.
const {prefix} = readLanguageFromPath(window.location.pathname)

root.render(
    <HelmetProvider>
        <Provider store={store}>
            <Suspense fallback={<Loader/>}>
                <BrowserRouter basename={`${prefix}/`}>
                    <App/>
                </BrowserRouter>
            </Suspense>
        </Provider>
    </HelmetProvider>
);

reportWebVitals();
